"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconThumbsDownOutline = _interopRequireDefault(require("./IconThumbsDownOutline"));
var IconThumbsUpOutline = /*#__PURE__*/(0, _styledComponents.default)(_IconThumbsDownOutline.default).withConfig({
  displayName: "IconThumbsUpOutline",
  componentId: "c11n-8-107-0__sc-y37b8x-0"
})(["transform:scaleY(-1);"]);
var _default = IconThumbsUpOutline;
exports.default = _default;